import React, { useState } from "react";

const PatientAnalyticsModal = ({ orgCode, patientId }) => {
  const isProd = process.env.REACT_APP_IS_TIMELINE_CONNECTED_WITH_PROD === "true";
  const timelineBaseUrl = isProd
    ? process.env.REACT_APP_TIMELINE_BASE_URL_PROD
    : process.env.REACT_APP_TIMELINE_BASE_URL_DEV;
  const analyticsUrl = `${timelineBaseUrl || process.env.REACT_APP_TIMELINE_BASE_URL_DEV}/patient/?org=${orgCode}&patient_id=${patientId}`;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center", // Centers the iframe horizontally
        alignItems: "center", // Optional: Centers the iframe vertically
        height: "100vh", // Takes full viewport height
      }}
    >
      <iframe
        src={analyticsUrl}
        width="97%"
        height="100%"
        style={{
          border: "none",
          maxWidth: "100%", // Ensures it doesn't exceed parent width
        }}
        title="Patient Analytics"
      />
    </div>
  );
};

export default PatientAnalyticsModal;
